import { ReactNode } from 'react'

import CommonLayout from '@/components/layouts/common/Layout'
import Navbar from '@/components/layouts/recipient/Navbar'

interface LayoutProps {
  children: ReactNode
}

/**
 * Recipient search layout component
 *
 * Provides consistent layout structure for recipient search pages.
 * Uses the common layout with recipient-specific navbar.
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <CommonLayout
      navbar={Navbar}
      innerClassName="bg-primary-50 dark:bg-default-dark"
    >
      {children}
    </CommonLayout>
  )
}

export const getLayout = (page: ReactNode) => <Layout>{page}</Layout>

export default Layout
